import { Grid } from "@material-ui/core"
import CbCategoria from "../cbCategoria"
import CbPaquete from "../cbPaquetes"
import FieldCatidadPasajero from "./FieldCatidadPasajero"
import FieldSalida from "./FieldFechaSalida"
import FieldMensualidades from "./FieldMensualidades"
import FieldHabitacion from "./FieldHabitacion"
import FieldExtras from "./FieldExtras"
import FieldCatalogoExtras from "./FieldCatalogoExtras"
import FieldAdultos from "./FieldAdultos"
const FCotizacion = () => {
    return (
        <div>
            <Grid container>
                <Grid item xs={6}>
                    <Grid container>
                        <Grid item xs={12}>
                            <CbCategoria />
                        </Grid>
                        <Grid item xs={12}>
                            <CbPaquete />
                        </Grid>
                        <Grid item xs={12}>
                            <FieldSalida />
                        </Grid>
                        <Grid item xs={12}>
                            <FieldMensualidades />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <Grid container>
                        <Grid item xs={12}>
                            <FieldCatalogoExtras />
                        </Grid>
                        <Grid item xs={12}>
                            <FieldExtras />
                        </Grid>
                        <Grid item xs={12}>
                            <FieldAdultos />
                        </Grid>
                        <Grid item xs={12}>
                            <FieldCatidadPasajero />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <FieldHabitacion />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}
export default FCotizacion